import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MobileActivateComponent } from "./mobile-activate.component";
import { Route, RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../_libs/material-module/material.module";
import { TryCatchMaterialFormsModule } from "../../@dodo/material-forms";
import { AppCoreModule } from "../_core/core.module";
import { DodoMatComponentsCommonModule } from "../../_libs/dodo-mat-components/dodo-mat-components-common.module";
import { DodoComponentsCommonModule } from "../../_libs/dodo-components/dodo-components-common.module";
import { DodoCtaButtonsModule } from "../../@dodo/cta-buttons/cta-buttons.module";

const MobileActivateRoutes: Route[] = [
	{
		path: "",
		component: MobileActivateComponent,
	},
];
@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild(MobileActivateRoutes),
		FormsModule,
		MaterialModule,
		ReactiveFormsModule,
		AppCoreModule,
		TryCatchMaterialFormsModule,
		DodoMatComponentsCommonModule,
		DodoComponentsCommonModule,
		DodoCtaButtonsModule
	],
	declarations: [MobileActivateComponent],
})
export class MobileActivateModule { }
